import React, { useState, useEffect } from "react";

import {
  Table,
  Button,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from "reactstrap";
// import classnames from 'classnames';
import "./Components.css";

export default function Problems(props) {
  const [problems, setProblems] = useState([]);
  // const [problemsCounter, setProblemscounter] = useState(false);
  let counter = 0;
  const [modalProblemList, setmodalProblemList] = useState([]);
  const [problemInvoiceId, setproblemInvoiceId] = useState();
  const [problemorderId, setproblemOrderId] = useState();
  const [problemtextareaValue, setProblemtextareaValue] = useState();
  // const [solvedClicked, setSolvedClicked] = useState(false);
  // const [solvedClickedIndex, setSolvedClickedIndex] = useState();
  const [updateTriger, setUpdateTriger] = useState(false);
  // const [forRemove, setForRemove] = useState();
  // const [idOfPrblem, setidOfPrblem] = useState();
  // let element = [];

  //   start of Modal realated states and function
  const {
    // buttonLabel,
    className,
  } = props;

  const [modal, setModal] = useState(false);
  // const [modalIndex, setModalIndex] = useState(-1);
  const toggle = () => {
    setModal(!modal);
  };

  const detailsHandler = (data) => {
    // for (let i = 1; i <= data.problems.length; i++) {
    //      element.push(data.problems[i]);
    //     setmodalProblemList(element)
    // }
    // console.log(data)
    setmodalProblemList(data.problems);
    setproblemInvoiceId(data.invoiceId);
    setproblemOrderId(data.orderId);
  };

  const solveHandler = (problem, problemId, problemDesc, index) => {
    const ProblemSolved = async (e) => {
      // e.preventDefault()
      try {
        const response = await fetch(
          `/api/v1/logistics/orders/item/problem/${problemInvoiceId}/${problemId}`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              solved: true,
              Description: problemDesc,
            }),
          }
        );
        console.log(response);
        if (response.ok) {
          setUpdateTriger(!updateTriger);
          // here waas a curly braces which showed warning, so I removed them
          props.page === "packing" && props.parentStateChanger(!props.update);

          let toRemove = problem;
          let index = modalProblemList.indexOf(toRemove);
          if (index > -1) {
            //Make sure item is present in the array, without if condition, -n indexes will be considered from the end of the array.
            modalProblemList.splice(index, 1);
            if (modalProblemList.length < 1) {
              toggle();
            }
          }
          console.log(modalProblemList);
        }
      } catch (e) {
        console.log(e);
        alert(e);
      }
    };
    ProblemSolved();
  };

  const handleProblemTextareaChange = (event) => {
    setProblemtextareaValue(event.target.value);
  };

  const updateProblemHandler = async (e) => {
    // e.preventDefault()
    if (problemtextareaValue !== null) {
      try {
        const response = await fetch(
          `/api/v1/logistics/orders/item/problem/${problemInvoiceId}/`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              Description: problemtextareaValue,
            }),
          }
        );
        console.log(response);
        if (response.ok) {
          // setUpdateCheckWatchTable(!updateCheckWatchTable);
          setUpdateTriger(!updateTriger);
          setProblemtextareaValue(null);
        }
        if (!response.ok) {
          const payload = await response.text();
          alert("Error "+ response.status + "\n" + "request was not successful" + "\n\n" + payload);
        }
      } catch (e) {
        console.log(e);
        alert(e);
      }
    }
  };

  const cancelHandler = async (e) => {
    // e.preventDefault()
    try {
      const response = await fetch(
        `/api/v1/logistics/orders/item/status/${problemInvoiceId}/`,
        {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            StatusName: "canceled",
          }),
        }
      );
      console.log(response);
      if (response.ok) {
        // setUpdateCheckWatchTable(!updateCheckWatchTable);
        setUpdateTriger(!updateTriger);
      }
    } catch (e) {
      console.log(e);
      alert(e);
    }
  };

  const fetchProblemApi = async () => {
    try {
      const response = await fetch(`/api/v1/logistics/orders/item/invoice/`, {
        method: "get",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
      });
      const payload = await response.json();
      setProblems(payload);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchProblemApi();
  }, [updateTriger, props.update]);
  return (
    <div
      className="container customContainer"
      style={
        props.page === "packing" ? { padding: 5, border: "1px solid red" } : {}
      }
    >
      <Badge className="mb-4" variant="info">
        <h1 className="h3">Probleme</h1>
      </Badge>
      <Row>
        <Col sm="12">
          <div>
            {/* <p>Probleme, noch offen: <strong>{problemsCounter}</strong> probleme</p> */}
            <Table striped bordered hover>
              {!(problems.length < 1) ? (
                <thead>
                  <tr>
                    <th>Digits</th>
                    <th>Auftragsnummer</th>
                    <th>Kurze Beschreibung und Probleme</th>
                    <th></th>
                  </tr>
                </thead>
              ) : null}
              <tbody>
                {problems.map((data, index) => {
                  if (problems.length < 1) {
                    return <h1>CONGRADULATION, THERE IS NO PROBLEM.</h1>;
                  }

                  if (data.hasProblem) {
                    counter = counter + 1;
                    return (
                      <tr key={index}>
                        <td>{data.statusDbDigit}</td>
                        <td>{data.orderId}</td>
                        <td className="lineBreak">
                          <p>
                            <b>{data.saleTitle}</b>
                          </p>
                          {data.problems.map((problem, index) => {
                            if (!problem.solved) {
                              return (
                                <span key={index} className="mr-1">
                                  {problem.description}/
                                </span>
                              );
                            }
                            return null;
                          })}
                        </td>
                        <td
                        // style={(data.invoiceIdsInOrder.length > 1) ? { backgroundColor: '#ffc107' } : {}}
                        >
                          <Button
                            color="primary"
                            onClick={() => {
                              toggle();
                              setProblemtextareaValue(null);
                              detailsHandler(data);
                            }}
                            // onClick={() => { docCollectedOkHandler(data.invoiceId, data) }}
                          >
                            Details
                          </Button>{" "}
                        </td>
                      </tr>
                    );
                  }
                  return null;
                })}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>

      <Modal
        size="lg"
        centered={true}
        isOpen={modal}
        toggle={toggle}
        className={className}
      >
        <ModalHeader toggle={toggle}>Problemdetails</ModalHeader>
        <ModalBody>
          <div>
            <ol
              style={{ maxHeight: "200px", overflow: "auto", paddingLeft: "0" }}
            >
              {modalProblemList.map((problem, index) => {
                if (!problem.solved) {
                  return (
                    <div
                      key={index}
                      // style={ (solvedClicked && solvedClickedIndex === index) ? { display: "none"} : {}}
                    >
                      <li
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          justifyContent: "space-between",
                          marginRight: "10px",
                        }}
                      >
                        <p>
                          <span style={{ paddingRight: "16px" }}>
                            <b>{problem.personName}:</b>
                          </span>
                          {problem.description}
                        </p>
                        {/* {modalProblemList} */}
                        <Button
                          color="success"
                          className="ml-3"
                          onClick={() => {
                            solveHandler(
                              problem,
                              problem.id,
                              problem.description,
                              index
                            );
                          }}
                        >
                          Problem gelöst
                        </Button>
                      </li>
                      <hr></hr>
                    </div>
                  );
                }
                return null;
              })}
            </ol>
          </div>
          <textarea
            style={{ width: "100%", height: "100px" }}
            placeholder="Im Falle eines neuen Problems, bitte hier Kommentar eintragen."
            onChange={handleProblemTextareaChange}
          ></textarea>
        </ModalBody>
        <ModalFooter style={{ justifyContent: "space-between" }}>
          {/* <Button color="success" onClick={toggle}>Solved</Button> */}
          <Button
            color="primary"
            onClick={() => {
              updateProblemHandler();
              toggle();
            }}
          >
            Problem hinzufügen
          </Button>{" "}
          <Button
            color="danger"
            onClick={() => {
              cancelHandler();
              toggle();
            }}
          >
            Auftrag {problemorderId} abbrechen
          </Button>
          <Button color="secondary" onClick={toggle}>
            Schließen
          </Button>
        </ModalFooter>
        {/* {console.log(modalProblemList)} */}
      </Modal>
    </div>
  );
}
